import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import { connect } from "lib/core/store"
import "./Submission.css"
import SubmissionElsewhere from "./SubmissionElsewhere"
import SubmissionFile from "./SubmissionFile"
import SubmissionText from "./SubmissionText"

const Submission = function (props) {
  const { content, step, completion, isLoading } = props
  const { onFileCleared, onFileSubmitted, onTextSubmitted } = props
  const { method } = content
  return (
    <div className="Submission Content__Submission Content--padded">
      {(() => {
        if (isLoading) {
          return <LoadingCircle inverted={true} />
        } else {
          switch (method) {
            case "submit_file":
              return (
                <SubmissionFile
                  {...Object.assign({}, content, {
                    completion: completion,
                    onFileCleared: onFileCleared,
                    onFileSubmitted: onFileSubmitted
                  })}
                />
              )
            case "submit_elsewhere":
              return <SubmissionElsewhere {...Object.assign({}, content)} />
            case "submit_text":
              return (
                <SubmissionText
                  {...Object.assign({}, content, {
                    completion: completion,
                    onTextSubmitted: onTextSubmitted
                  })}
                />
              )
          }
        }
      })()}
    </div>
  )
}
Submission.displayName = "Submission"

const mapStateToProps = function (state, ownProps) {
  const { completion } = state.stepStore.state
  const isLoading = !completion

  const completeAction = function (completionData, isCompleted) {
    if (isCompleted == null) {
      isCompleted = true
    }
    // handleLegacyContentCompletion not needed or present when in certain cases (i.e. in CompletionFeedbackPanel )
    ownProps.handleLegacyContentCompletion &&
      ownProps.handleLegacyContentCompletion(
        !isCompleted /* isCompletionDisabled */
      )
    return state.stepStore.action.setCompletionData(completionData)
  }

  const onFileSubmitted = function (file) {
    const completionData = {
      submission_file_url: file.url,
      submission_file_name: file.filename
    }
    return completeAction(completionData)
  }

  const onTextSubmitted = function (text) {
    const completionData = { submission_text: text }
    return completeAction(completionData, !!text)
  }

  const onFileCleared = function () {
    const completionData = {
      submission_file_url: null,
      submission_file_name: null,
      submission_file_image: null
    }
    return completeAction(completionData, false)
  }

  const props = _.assign(
    {},
    {
      onFileCleared,
      onFileSubmitted,
      onTextSubmitted,
      completion,
      isLoading
    },
    ownProps
  )

  return props
}

export default connect(Submission, "step", mapStateToProps, ["completion"])
